import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Api from '../components/Config';

import MyNavBar from '../components/MyNavBar';
import AdminNavBar from '../components/AdminNavBar';

const AuthenticatedRoute = ({ component: Component, isAdminPage, ...rest }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [userObj, setUserObj] = useState(null);

  useEffect(() => {
    const validateUid = async () => {
      const UID = localStorage ? localStorage.getItem('UID') : false;
      if (UID) {
        const data = await Api.validate(UID);
        if (data.RESULT == 'SUCCESS') {
          setUserObj({ loggedIn: true, IS_ADMIN: data.IS_ADMIN, role: data.ROLE });
        }
      }
      setIsLoaded(true);
    };
    validateUid();
  }, []);

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (isLoaded) {
          if (userObj === null) {
            return <Redirect to={{ pathname: '/', state: { from: matchProps.location, isAdminPage } }} />;
          }

          const navBar = isAdminPage ? <AdminNavBar {...matchProps} /> : <MyNavBar {...matchProps} />;
          return (
            <div className="container">
              {navBar}
              <Component userObj={userObj} {...matchProps} />
            </div>
          );
        }

        // still Loading
        return <div></div>;
      }}
    />
  );
};

export default AuthenticatedRoute;
